module.exports = __webpack_public_path__ + "iransans.557b8fcf830fe3d0faaa.woff";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/assets/fonts/iransans.woff
// module id = ../../../../../src/assets/fonts/iransans.woff
// module chunks = styles